import {Button, ButtonBase, makeStyles} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Ballot, HomeRounded} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useParams} from 'react-router';
import {pushRoute} from '../../../routes';
import {Input} from '../../../shared/components';
import ButtonWhatsApp from '../../../shared/components/buttons/ButtonWhatsApp';
import DetachedIcon from '../../../shared/components/detachedIcon';
import {getUrlShareReceipt} from '../../../shared/helpers/getApiFromLocation';
import {getInfo, getUser} from '../../auth/store/selectors';
import HelpSection from '../components/HelpSection';
import ReceiptDialog from '../components/ReceiptDialog';
import Screen from '../screen';
import './receiptConsult.css';

const useStyles = makeStyles(() => ({
  buttonProgress: {
    color: 'green',
    left: '50%',
    marginLeft: -12,
    marginTop: -12,
    position: 'absolute',
    top: '50%',
  },
}));

const ReceiptConsult: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [code, setCode] = useState<string>('');
  const [receiptUrl, setReceiptUrl] = useState<string>('');
  const [openReceipt, setOpenReceipt] = useState<boolean>(false);
  const {loading, message} = useSelector(getInfo);
  const {receiptCode} = useParams();
  const queryParams = new URLSearchParams(useLocation().search);
  const user = useSelector(getUser);
  const userId = user && user.id ? user.id.toString() : '';
  const locale =
    queryParams.get('locale') ||
    localStorage.getItem('SEI_POCKET_LOCALE') ||
    'pt';

  useEffect(() => {
    if (receiptCode) {
      setReceiptUrl(getUrlShareReceipt(receiptCode, locale, userId));
      setOpenReceipt(true);
    }
  }, [receiptCode]);

  const send = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    window.history.pushState('', '', `/cc/${code}?locale=${locale}`);
    setReceiptUrl(getUrlShareReceipt(code, locale, userId));
    setOpenReceipt(true);
  };

  const closeDialog = (action: string) => {
    setOpenReceipt(false);

    setCode('');
    setReceiptUrl('');
    window.history.pushState('', '', '/consultar-comprovante');
  };

  return (
    <Screen isPageAuth={false} className="receipt-consult">
      <form className="auth-form boxed-forms-300" onSubmit={send}>
        <DetachedIcon size="sm" icon={<Ballot />} />

        <h2 className="primary-title"> {t('consultar-comprovante.titulo')} </h2>
        <p className="default-subtitle mt-0">
          {t('consultar-comprovante.sub-title')}
        </p>
        <Input
          label={t('consultar-comprovante.codigo')}
          className="full-width"
          placeholder={t('consultar-comprovante.codigo-placeholder')}
          name="code"
          type="text"
          required={true}
          autoFocus={true}
          value={code}
          onChange={ev => setCode(ev.target.value)}
        />

        {message && <p style={{color: 'red'}}>{message}</p>}

        <ButtonBase
          className={`button-default btn-color-green full-width`}
          type="submit"
          disabled={loading}
        >
          {loading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}{' '}
          {loading
            ? t('consultar-comprovante.aguarde')
            : t('consultar-comprovante.consultar')}
        </ButtonBase>
        <HelpSection />

        <>
          <hr className={`full-width `} />

          <Button
            className={`full-width `}
            type="button"
            color="primary"
            onClick={() => dispatch(pushRoute('welcome'))}
            startIcon={<HomeRounded />}
          >
            {t('consultar-comprovante.inicio')}
          </Button>
        </>
      </form>

      <ButtonWhatsApp />

      <ReceiptDialog
        receiptUrl={receiptUrl}
        open={openReceipt}
        onClose={closeDialog}
      />
    </Screen>
  );
};
export default ReceiptConsult;



// WEBPACK FOOTER //
// ./src/features/election/ReceiptConsult/ReceiptConsult.tsx